import { render } from "./index.vue?vue&type=template&id=81376516"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=81376516&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/search-result/template4/index.vue'],['render',render],['__file',"index.vue"]])

export default __exports__